// @ts-nocheck
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import KwPanel from '../../common/KwPanel';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { useForm } from 'react-hook-form';
import EditNumberOfKeysForm from '../components/EditNumberOfKeysForm';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { updateNumberOfKeys } from '../../../api/requestApi';

export interface EditNumberOfKeysProps {
  done: (data: any) => void;
  cancel: () => void;
  request: any;
}

export default function EditNumberOfKeys({ done, cancel, request }: EditNumberOfKeysProps) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
  } = useForm();
  const [processing, setProcessing] = useState();
  const { t } = useTranslation();

  const onSubmit = (data) => {
    setProcessing(true);
    updateNumberOfKeys(request.id, data.newNumberOfKeys, data.reason)
      .then((d) => {
        toast.success(t('Request updated'));
        done(d);
        setProcessing(false);
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to update request'));
        setProcessing(false);
      });
  };

  return (
    <SlideoutLayout
      title={t('Edit number of keys')}
      cancel={cancel}
      bar={
        <Button
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          isDisabled={processing}
          title={processing ? t('Processing') : t('Save changes')}
          text={t('Save changes')}
        />
      }
    >
      <KwPanel className="mb-4 form-horizontal">
        <EditNumberOfKeysForm
          request={request}
          register={register}
          errors={errors}
          control={control}
          getValues={getValues}
        ></EditNumberOfKeysForm>
      </KwPanel>
    </SlideoutLayout>
  );
}
